import {
  required,
  requiredIf,
} from 'vuelidate/lib/validators';

export default {
  origin: {
    first_name: {
      required: requiredIf(form => {
        // console.log("firstname required", _.isEmpty(form.last_name), _.isEmpty(form.company));
        return _.isEmpty(form.last_name) && _.isEmpty(form.company);
      })
    },
    last_name: {
      required: requiredIf(form => {
        // console.log("lastname required", _.isEmpty(form.first_name) ,_.isEmpty(form.company))
        return _.isEmpty(form.first_name) && _.isEmpty(form.company);
      })
    },
    company: {
      required: requiredIf(form => {
        // console.log("company required", _.isEmpty(form.first_name) ,_.isEmpty(form.last_name))
        return _.isEmpty(form.first_name) && _.isEmpty(form.last_name);
      })
    },
    address: { required },
    city: { required },
    state: { required },
    postal: { required },
    postal_origin: { required },
  },
  validationGroup: [
    'origin',
  ]
};



// WEBPACK FOOTER //
// ./resources/assets/js/views/Orders/Import/validations.js